/**
 * Formata mensagens de erro da API
 * Trata especialmente erros de validação (422) que incluem detalhes no objeto 'errors'
 * 
 * @param {Error} error - Objeto de erro do axios
 * @param {string} defaultMessage - Mensagem padrão caso não haja erro específico
 * @returns {string} - Mensagem de erro formatada
 */
export function formatError(error, defaultMessage = 'Erro ao processar solicitação.') {
  // Se não houver resposta, retorna mensagem padrão
  if (!error?.response?.data) {
    return defaultMessage;
  }

  const errorData = error.response.data;

  // Se houver erros de validação (objeto 'errors'), formata cada um
  if (errorData.errors && typeof errorData.errors === 'object') {
    const errorsArray = [];
    
    // Itera sobre cada campo com erro
    Object.keys(errorData.errors).forEach((field) => {
      const fieldErrors = errorData.errors[field];
      
      // Se for um array de erros (formato padrão do Laravel)
      if (Array.isArray(fieldErrors)) {
        fieldErrors.forEach((errorMessage) => {
          // Traduz nomes de campos comuns para português mais amigável
          const fieldLabel = translateFieldName(field);
          errorsArray.push(`${fieldLabel}: ${errorMessage}`);
        });
      } else if (typeof fieldErrors === 'string') {
        // Se for uma string única
        const fieldLabel = translateFieldName(field);
        errorsArray.push(`${fieldLabel}: ${fieldErrors}`);
      }
    });

    // Se encontrou erros formatados, retorna todos
    if (errorsArray.length > 0) {
      return errorsArray.join('\n');
    }
  }

  // Se houver apenas uma mensagem geral, retorna ela
  if (errorData.message) {
    return errorData.message;
  }

  // Fallback para mensagem padrão
  return defaultMessage;
}

/**
 * Traduz nomes de campos técnicos para português mais amigável
 * 
 * @param {string} field - Nome do campo em inglês
 * @returns {string} - Nome do campo em português
 */
function translateFieldName(field) {
  const translations = {
    name: 'Nome',
    email: 'E-mail',
    password: 'Senha',
    password_confirmation: 'Confirmação de senha',
    description: 'Descrição',
    amount: 'Valor',
    date: 'Data',
    account_id: 'Conta',
    category_id: 'Categoria',
    type: 'Tipo',
    initial_balance: 'Saldo inicial',
    color: 'Cor',
    notes: 'Observações',
    is_active: 'Status',
    is_paid: 'Status de pagamento',
    day_of_month: 'Dia do mês',
    start_date: 'Data de início',
  };

  return translations[field] || field;
}
